<template>
    <div class="lucky-cards-wrap">
        <v-row class="lucky-cards-list">
            <!-- <v-col cols="6" md="4" class="lucky-cards-list__item">
                <lucky-card-dialog v-model="dialog">
                    <template #activator="{ on, attrs }">
                        <v-card flat v-bind="attrs" v-on="on" class="lucky-card"></v-card>
                    </template>
                </lucky-card-dialog>
            </v-col> -->
            <v-col cols="6" md="4" class="lucky-cards-list__item">
                <v-card flat class="lucky-card" :disabled="loading" @click="clover"></v-card>
            </v-col>
            <v-col cols="6" md="4" class="lucky-cards-list__item">
                <v-card flat class="lucky-card" :disabled="loading" @click="clover"></v-card>
            </v-col>
            <v-col cols="6" md="4" class="lucky-cards-list__item">
                <v-card flat class="lucky-card" :disabled="loading" @click="clover"></v-card>
            </v-col>
            <v-col cols="6" md="4" class="lucky-cards-list__item">
                <v-card flat class="lucky-card" :disabled="loading" @click="clover"></v-card>
            </v-col>
            <v-col cols="6" md="4" class="lucky-cards-list__item">
                <v-card flat class="lucky-card" :disabled="loading" @click="clover"></v-card>
            </v-col>
            <v-col cols="6" md="4" class="lucky-cards-list__item">
                <v-card flat class="lucky-card" :disabled="loading" @click="clover"></v-card>
            </v-col>
        </v-row>
        <!-- <lucky-card-dialog v-model="dialog" /> -->
        <CardDialog ref="cardDialog"/>
        <AlreadyDialog ref="alreadyDialog"/>
    </div>
</template>

<script>
import api from "@/api";
import LuckyCardDialog from "@/components/client/event/clover/lucky-card-dialog.vue";
import CardDialog from "@/components/client/event/clover/card-dialog.vue";
import AlreadyDialog from "@/components/client/event/clover/already-dialog.vue";

export default {
    components: {
        LuckyCardDialog,
        CardDialog,
        AlreadyDialog
    },
    data() {
        return {
            dialog: false,
            loading: false
        };
    },
    computed: {
        logon() {
            return !!this.$store.state.accessToken;
        },
    },
    methods: {
        async clover() {
            this.loading = true
            if (this.logon) {
                let { log } = await api.v1.clover.logs.confirm();
                if(!log) {
                    let { config } = await api.v1.clover.logs.post();
                    this.config = config;
                    this.$refs.cardDialog.open(this.config)
                    this.$emit("init")
                } else {
                    this.$refs.alreadyDialog.open()
                }
            } else {
                alert("행운카드 이벤트는 로그인 후 참여할 수 있습니다.");
                this.$router.push("/login");
            }
            this.loading = false
        },
    },
};
</script>

<style lang="scss" scoped>
.lucky-cards-wrap {
    max-width: calc(272 / 360 * 100%);
    margin: 0 auto;
    .lucky-card {
        cursor: pointer;
        background-color: transparent;
        background-size: cover;
        background-repeat: no-repeat;
        box-shadow: 0 0 8px 0 #63c535;
        border-radius: 10px;
        aspect-ratio: 196 / 248;
        -webkit-transition: all ease-out 0.2s;
        -ms-transition: all ease-out 0.2s;
        transition: all ease-out 0.2s;
    }
    .lucky-cards-list {
        &__item {
            &:nth-child(1) {
                .lucky-card {
                    background-image: url(/images/event/clover/lucky-card-1.svg);
                }
            }
            &:nth-child(2) {
                .lucky-card {
                    background-image: url(/images/event/clover/lucky-card-2.svg);
                }
            }
            &:nth-child(3) {
                .lucky-card {
                    background-image: url(/images/event/clover/lucky-card-3.svg);
                }
            }
            &:nth-child(4) {
                .lucky-card {
                    background-image: url(/images/event/clover/lucky-card-4.svg);
                }
            }
            &:nth-child(5) {
                .lucky-card {
                    background-image: url(/images/event/clover/lucky-card-1.svg);
                }
            }
            &:nth-child(6) {
                .lucky-card {
                    background-image: url(/images/event/clover/lucky-card-1.svg);
                }
            }
        }
    }
}

@media (min-width: 768px) {
    .lucky-cards-wrap {
        max-width: calc(636 / 1920 * 100%);
        .lucky-cards-list {
            &__item {
                &:nth-child(n + 4):nth-child(-n + 6) {
                    padding-top: 48px;
                }
            }
        }
        .lucky-card {
            border-radius: 14px;
        }
        .lucky-cards-list {
            &__item {
                &:nth-child(1) {
                    .lucky-card {
                        background-image: url(/images/event/clover/lucky-card-1.svg);
                        &:hover {
                            background-image: url(/images/event/clover/lucky-card-hover-1.svg);
                        }
                    }
                }
                &:nth-child(2) {
                    .lucky-card {
                        background-image: url(/images/event/clover/lucky-card-2.svg);
                        &:hover {
                            background-image: url(/images/event/clover/lucky-card-hover-2.svg);
                        }
                    }
                }
                &:nth-child(3) {
                    .lucky-card {
                        background-image: url(/images/event/clover/lucky-card-3.svg);
                        &:hover {
                            background-image: url(/images/event/clover/lucky-card-hover-3.svg);
                        }
                    }
                }
                &:nth-child(4) {
                    .lucky-card {
                        background-image: url(/images/event/clover/lucky-card-4.svg);
                        &:hover {
                            background-image: url(/images/event/clover/lucky-card-hover-4.svg);
                        }
                    }
                }
                &:nth-child(5) {
                    .lucky-card {
                        background-image: url(/images/event/clover/lucky-card-1.svg);
                        &:hover {
                            background-image: url(/images/event/clover/lucky-card-hover-5.svg);
                        }
                    }
                }
                &:nth-child(6) {
                    .lucky-card {
                        background-image: url(/images/event/clover/lucky-card-1.svg);
                        &:hover {
                            background-image: url(/images/event/clover/lucky-card-hover-6.svg);
                        }
                    }
                }
            }
        }
    }
}
</style>